import { Directive, Input, TemplateRef, ViewContainerRef, Output, EventEmitter, NgModule } from '@angular/core';
var NgTranscludeDirective = /** @class */ (function () {
    function NgTranscludeDirective(_viewRef) {
        this._viewRef = _viewRef;
        this.ngTranscludeChange = new EventEmitter();
        this.viewRef = _viewRef;
    }
    Object.defineProperty(NgTranscludeDirective.prototype, "ngTransclude", {
        get: function () {
            return this._ngTransclude;
        },
        set: function (templateRef) {
            this._ngTransclude = templateRef;
            if (templateRef) {
                this.viewRef.createEmbeddedView(templateRef);
            }
        },
        enumerable: true,
        configurable: true
    });
    NgTranscludeDirective.prototype.ngAfterContentInit = function () {
        this.ngTranscludeChange.emit(true);
    };
    NgTranscludeDirective.prototype.ngOnDestroy = function () {
        this.viewRef.detach();
    };
    NgTranscludeDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[ngTransclude]'
                },] },
    ];
    /** @nocollapse */
    NgTranscludeDirective.ctorParameters = function () { return [
        { type: ViewContainerRef, },
    ]; };
    NgTranscludeDirective.propDecorators = {
        "ngTransclude": [{ type: Input },],
        "ngTranscludeChange": [{ type: Output },],
    };
    return NgTranscludeDirective;
}());
export { NgTranscludeDirective };
var NgTranscludeModule = /** @class */ (function () {
    function NgTranscludeModule() {
    }
    NgTranscludeModule.decorators = [
        { type: NgModule, args: [{
                    exports: [NgTranscludeDirective],
                    declarations: [NgTranscludeDirective]
                },] },
    ];
    /** @nocollapse */
    NgTranscludeModule.ctorParameters = function () { return []; };
    return NgTranscludeModule;
}());
export { NgTranscludeModule };
//# sourceMappingURL=common.js.map